<template>
  <b-card class="card-profile-1 mb-30 text-center">
    <h5 class="m-0 user-name">
      {{ $utils.getUserName(user) }}
    </h5>
    <TicketTaskCount :user="user" />
    <TimeRow :user="user" />

    <div class="avatar mb-3">
      <avatar
        :user="user"
        :hide-nick-name="true"
        :width="100"
        :width-in-percent="true"
      />
    </div>

    <OverdueRow :user="user" />
    <LeaveRow :user="user" />

    <router-link
      :to="
        `/Team/User/${user.firstName.toLowerCase()}-${user.lastName.toLowerCase()}`
      "
    >
      <button class="btn btn-primary btn-rounded mt-2 thin no-margin">
        Schedule
      </button>
    </router-link>
  </b-card>
</template>

<script>
import avatar from "@/components/projectAvatar"
import TicketTaskCount from "@/components/teammember/userBlock/ticketTaskCount"
import TimeRow from "@/components/teammember/userBlock/timeRow"
import OverdueRow from "@/components/teammember/userBlock/overdueRow"
import LeaveRow from "@/components/teammember/userBlock/leaveRow"

export default {
  name: "UserBlock",
  components: {
    avatar,
    TicketTaskCount,
    TimeRow,
    OverdueRow,
    LeaveRow
  },
  props: {
    hideCard: { required: false, type: Boolean, default: false },
    user: {
      required: true,
      type: Object
    }
  },
  data() {
    return {}
  },

  created() {}
}
</script>

<style scoped>
.user-card {
  margin-bottom: 15px;
}
.inline {
  display: inline-block;
}
.b-dropdown {
  position: absolute;
  right: 0;
  top: 0;
}
.greyed {
  background: #eeeeee;
}
.thin {
  padding: 5px 10px;
  font-size: 12px;
}
.carousel-cell {
  width: 100%;
}
.project-stats {
  text-align: left;
  max-width: 250px;
  margin: auto;
  margin-bottom: 10px;
}
.project-stats:last-child {
  margin-bottom: 0px !important;
}
.project-stats p {
  margin: 0;
}
.project-stats .details p {
  float: right;
  font-size: 75%;
  padding-right: 0px !important;
}
.project-stats .details * {
  padding: 5px 10px !important;
}
.overdue {
  color: red;
  font-weight: bold;
}
.avatar {
  min-height: 16vh;
}
.badge {
  white-space: unset !important;
}
.ticket {
  color: darkmagenta;
}
.numbers-grid {
  display: grid;
  grid-template-areas: "tasksArea ticketsArea timeArea";
  grid-template-columns: 3fr 3fr 7fr;

  /* margin-bottom: 2rem; */
}

.tasks-area {
  grid-area: tasksArea;
  padding: 0.02rem;
  white-space: nowrap;
}

.tickets-area {
  grid-area: ticketsArea;
  padding: 0.02rem;
  white-space: nowrap;
}

.time-area {
  grid-area: timeArea;
  text-align: right;
  margin-right: 0.5rem;
}

.no-padding {
  padding: 0 !important;
  text-align: left;
}

.clock-custom {
  vertical-align: text-bottom;
}

.align-left {
  text-align: left;
}

.align-right {
  text-align: right;
}

.no-margin {
  margin: 0 !important;
}
.user-name {
  font-weight: bold;
}
</style>
